export class OrgDangerTab extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  private render() {
    this.innerHTML = `
      <div style="display: flex; flex-direction: column; gap: 40px; max-width: 800px;">
        <div class="sketchy-card" style="border-color: rgba(255, 165, 0, 0.3);">
          <div style="position: relative; z-index: 2;">
            <h3 style="margin: 0 0 4px 0; color: #ff9800; font-family: var(--font-sketch);">Key Rotation</h3>
            <p style="margin: 0 0 16px 0; font-size: 0.85rem; color: var(--text-dim);">This operation performs a live rotation with zero downtime.</p>
            
            <div style="display: flex; flex-direction: column; gap: 16px;">
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px; background: rgba(255, 165, 0, 0.05); border-radius: 4px;">
                  <div>
                      <div style="font-weight: 500; margin-bottom: 4px; color: var(--text-main);">Secrets Encryption Key</div>
                      <div style="font-size: 0.85rem; color: var(--text-dim);">Rotates the organization's master key for secrets and re-encrypts all secrets.</div>
                  </div>
                  <app-button variant="secondary" id="btn-rotate-secrets" size="sm">Rotate</app-button>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px; background: rgba(255, 165, 0, 0.05); border-radius: 4px;">
                  <div>
                      <div style="font-weight: 500; margin-bottom: 4px; color: var(--text-main);">Agent Vault Encryption Key</div>
                      <div style="font-size: 0.85rem; color: var(--text-dim);">Rotates the organization's master key for the agent vault and re-encrypts all entries.</div>
                  </div>
                  <app-button variant="secondary" id="btn-rotate-agentvault" size="sm">Rotate</app-button>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px; background: rgba(255, 165, 0, 0.05); border-radius: 4px;">
                  <div>
                      <div style="font-weight: 500; margin-bottom: 4px; color: var(--text-main);">RSA Transport Key</div>
                      <div style="font-size: 0.85rem; color: var(--text-dim);">Rotates the public/private key pair used for transporting secrets. Inflight requests using the old key may fail.</div>
                  </div>
                  <app-button variant="secondary" id="btn-rotate-rsa" size="sm">Rotate</app-button>
              </div>
            </div>
          </div>
        </div>

        <div class="sketchy-card" style="border-color: rgba(255, 68, 68, 0.3);">
          <div style="position: relative; z-index: 2;">
            <h3 style="margin: 0 0 16px 0; color: #ff4444; font-family: var(--font-sketch);">Danger Zone</h3>
            
            <div style="display: flex; flex-direction: column; gap: 16px;">
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px; background: rgba(255, 68, 68, 0.05); border-radius: 4px;">
                  <div>
                      <div style="font-weight: 500; margin-bottom: 4px; color: var(--text-main);">Delete Organization</div>
                      <div style="font-size: 0.85rem; color: var(--text-dim);">Once you delete an organization, there is no going back. Please be certain.</div>
                  </div>
                  <app-button variant="danger" id="btn-delete-org" size="sm">Delete</app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    this.setupListeners();
  }

  private setupListeners() {
    const rotateSecretsBtn = this.querySelector('#btn-rotate-secrets');
    if (rotateSecretsBtn) {
      rotateSecretsBtn.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('rotate-secrets-key', { bubbles: true, composed: true }));
      });
    }

    const rotateAgentVaultBtn = this.querySelector('#btn-rotate-agentvault');
    if (rotateAgentVaultBtn) {
      rotateAgentVaultBtn.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('rotate-agentvault-key', { bubbles: true, composed: true }));
      });
    }

    const rotateRsaBtn = this.querySelector('#btn-rotate-rsa');
    if (rotateRsaBtn) {
      rotateRsaBtn.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('rotate-rsa-key', { bubbles: true, composed: true }));
      });
    }

    const deleteBtn = this.querySelector('#btn-delete-org');
    if (deleteBtn) {
      deleteBtn.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('delete-org', { bubbles: true, composed: true }));
      });
    }
  }
}

if (!customElements.get('org-danger-tab')) {
  customElements.define('org-danger-tab', OrgDangerTab);
}
